<importer-sub-header title="Republish Logs"></importer-sub-header>

<div class="upload-field">
  <coin-v2-button
    [type]="'primary'"
    [icon]="'upload'"
    [iconPos]="'right'"
    [text]="'Republish Base Elements'"
    (click)="openObjectRefresherPopup()"></coin-v2-button>
</div>

<importer-simple-table
  [header]="selectedTableHeaders"
  [service]="republishService"
  [serverPaginated]="true"
  [serverside]="true"
  [presetQueryParams]="queryParameters$ | async"
  [isExpectedToChange]="isExpectedToChange"
  [updaterIntervalInMs]="updaterIntervalInMs">
  <ng-template
    #columns
    let-item>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <i
              class="edit-button material-icons"
              (click)="loadSummary(item)">
              {{ item.state === 'Staged' ? 'edit' : 'visibility' }}
            </i>
          </div>
        }
      </div>
    </ng-container>

    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p [class.error]="item.state === 'Failed'">
              {{ item.fileType.displayedName }}
            </p>
          </div>
        }
      </div>
    </ng-container>

    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p class="ps ps--finalized">
              {{ item.state }}
            </p>
          </div>
        }
      </div>
    </ng-container>

    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            @if (item.selectedElement) {
              @if (item.selectedElement?.indexOf('LOG_ID') === -1) {
                <p>{{ item.selectedElement }}</p>
              } @else {
                <p
                  class="republished-changes"
                  (click)="openLog(getLogId(item.selectedElement))">
                  Changes from previous import
                </p>
              }
            } @else {
              <p>all objects</p>
            }
          </div>
        }
      </div>
    </ng-container>

    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p [class.error]="item.state === 'Failed'">
              {{ item.republishedAt | date: 'MMM d, y' }}
              <br />
              {{ item.republishedAt | date: '(HH:mm, z)' : 'UTC' }}
            </p>
          </div>
        }
      </div>
    </ng-container>

    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p [class.error]="item.state === 'Failed'">
              {{ item.republishedBy.firstname }} {{ item.republishedBy.lastname }}
              <br />
              (GID: {{ item.republishedBy.gid }})
            </p>
          </div>
        }
      </div>
    </ng-container>
  </ng-template>
</importer-simple-table>
